import { isEmpty } from "lodash-es";
import React, { FC, memo } from "react";

import { IConsultantProfile, IConsultantProfileSkill } from "@/data/consultant-profiles";
import { ISkillsListProps, SkillsList } from "@/views/components/Skills";

interface Props extends Pick<ISkillsListProps, "showMore" | "visibleSkillsCount"> {
  profile: IConsultantProfile;
}

const getSkillKey = (s: IConsultantProfileSkill) => `badge-${s.skill.id}`;
const getSkillText = (s: IConsultantProfileSkill) => s.skill.name;

export const ProfileSkills: FC<Props> = memo(({ profile, children, ...rest }) => {
  return !isEmpty(profile.skills) || children ? (
    <SkillsList list={profile.skills} getKey={getSkillKey} getText={getSkillText} {...rest}>
      {children}
    </SkillsList>
  ) : null;
});
